import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoCustomLists = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 520.051,
	height: 391.634,
	viewBox: "0 0 520.051 391.634",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13405",
				"data-name": "Rectangle 13405",
				width: 430.275,
				height: 332.72,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-2",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13404",
				"data-name": "Rectangle 13404",
				width: 405.43,
				height: 332.721,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-3",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13403",
				"data-name": "Rectangle 13403",
				width: 13.264,
				height: 277.189,
				fill: "#edf4fa"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-4",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13424",
				"data-name": "Rectangle 13424",
				width: 335.052,
				height: 254.138,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-6",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13418",
				"data-name": "Rectangle 13418",
				width: 79.417,
				height: 79.417,
				transform: "translate(83.617 42.624)",
				fill: "none"
			})
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_7654",
		"data-name": "Group 7654",
		transform: "translate(17044.027 1308.5)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group_7646",
			"data-name": "Group 7646",
			transform: "translate(-283.483 -964.918)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_13001",
				"data-name": "Path 13001",
				d: "M473.974,391.638c18.089-29.66,43.5-86.417,45.655-123.077,3.181-54.193-11.89-55.916-37.062-84.047-10.979-12.269,19.85-51.083-26.95-83.146-29.036-19.893-68.186,20.109-92.276-29.5C333.487,10.382,230.642-4.275,174.6.993,88.96,9.043,31.647,58.346,17.148,91.025-35.563,209.833,53.093,217.286,20.94,275.162-4.82,321.531,34.4,372.068,47.37,387.952Z",
				transform: "translate(-16760.545 -343.585)",
				fill: "#edf4fa"
			}), /* @__PURE__ */ _jsx("g", {
				id: "Group_7645",
				"data-name": "Group 7645",
				transform: "translate(-16698.391 -305.668)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_7644",
					"data-name": "Group 7644",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_7643",
						"data-name": "Group 7643",
						transform: "translate(15.289 -0.001)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_7642",
							"data-name": "Group 7642",
							children: [
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12985",
									"data-name": "Path 12985",
									d: "M1323.46,307.184l-207.914-7.8a7.11,7.11,0,0,1-6.839-7.372L1119.4,6.839A7.11,7.11,0,0,1,1126.776,0l207.914,7.8a7.11,7.11,0,0,1,6.839,7.372l-10.7,285.174a7.11,7.11,0,0,1-7.372,6.839",
									transform: "translate(-999.593 0.005)",
									fill: "#d3e6f5"
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_7641",
									"data-name": "Group 7641",
									transform: "translate(310.602 29.999)",
									opacity: .22,
									style: {
										mixBlendMode: "multiply",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_7640",
										"data-name": "Group 7640",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_7639",
											"data-name": "Group 7639",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_12986",
												"data-name": "Path 12986",
												d: "M2904.515,267.359l13.264,277.189h-13.264Z",
												transform: "translate(-2904.514 -267.359)",
												fill: "#edf4fa"
											})
										})
									})
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12988",
									"data-name": "Path 12988",
									d: "M1145.717,496.475a7.11,7.11,0,0,1-7.11,7.11H930.547a7.11,7.11,0,0,1-7.11-7.11V211.1a7.11,7.11,0,0,1,7.11-7.11h208.06a7.11,7.11,0,0,1,7.11,7.11",
									transform: "translate(-835.115 -181.101)",
									fill: "#fff"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12989",
									"data-name": "Path 12989",
									d: "M1590.074,524.462h-80.1a5.947,5.947,0,0,1,0-11.893h80.1a5.947,5.947,0,0,1,0,11.893",
									transform: "translate(-1350.561 -455.057)",
									fill: "#042479"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12990",
									"data-name": "Path 12990",
									d: "M1334.78,815.963H1180.815a5.947,5.947,0,0,1,0-11.893H1334.78a5.947,5.947,0,1,1,0,11.893",
									transform: "translate(-1058.335 -713.851)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12991",
									"data-name": "Path 12991",
									d: "M1334.78,1107.464H1180.815a5.947,5.947,0,0,1,0-11.893H1334.78a5.947,5.947,0,1,1,0,11.893",
									transform: "translate(-1058.335 -972.646)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12992",
									"data-name": "Path 12992",
									d: "M1334.78,1398.964H1180.815a5.947,5.947,0,0,1,0-11.893H1334.78a5.947,5.947,0,1,1,0,11.893",
									transform: "translate(-1058.335 -1231.439)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12993",
									"data-name": "Path 12993",
									d: "M1527.939,1847.257h-94.651a5.947,5.947,0,1,1,0-11.893h94.651a5.947,5.947,0,0,1,0,11.893",
									transform: "translate(-1282.48 -1629.433)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12994",
									"data-name": "Path 12994",
									d: "M1187.484,1841.311a5.947,5.947,0,1,1-5.947-5.947,5.947,5.947,0,0,1,5.947,5.947",
									transform: "translate(-1058.976 -1629.433)",
									fill: "#042479"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12995",
									"data-name": "Path 12995",
									d: "M1527.939,2052.623h-94.651a5.947,5.947,0,1,1,0-11.894h94.651a5.947,5.947,0,0,1,0,11.894",
									transform: "translate(-1282.48 -1811.755)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12996",
									"data-name": "Path 12996",
									d: "M1187.484,2046.676a5.947,5.947,0,1,1-5.947-5.947,5.947,5.947,0,0,1,5.947,5.947",
									transform: "translate(-1058.976 -1811.755)",
									fill: "#042479"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12997",
									"data-name": "Path 12997",
									d: "M1527.939,2257.987h-94.651a5.947,5.947,0,1,1,0-11.893h94.651a5.947,5.947,0,1,1,0,11.893",
									transform: "translate(-1282.48 -1994.078)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12998",
									"data-name": "Path 12998",
									d: "M1187.484,2252.041a5.947,5.947,0,1,1-5.947-5.947,5.947,5.947,0,0,1,5.947,5.947",
									transform: "translate(-1058.976 -1994.078)",
									fill: "#042479"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12999",
									"data-name": "Path 12999",
									d: "M1527.939,2463.353h-94.651a5.947,5.947,0,1,1,0-11.893h94.651a5.947,5.947,0,1,1,0,11.893",
									transform: "translate(-1282.48 -2176.401)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_13000",
									"data-name": "Path 13000",
									d: "M1187.484,2457.406a5.947,5.947,0,1,1-5.947-5.947,5.947,5.947,0,0,1,5.947,5.947",
									transform: "translate(-1058.976 -2176.401)",
									fill: "#042479"
								})
							]
						})
					})
				})
			})]
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_7653",
			"data-name": "Group 7653",
			transform: "translate(-16960 -1174.004)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_7652",
				"data-name": "Group 7652",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_7651",
					"data-name": "Group 7651",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_7650",
						"data-name": "Group 7650",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13003",
								"data-name": "Path 13003",
								d: "M309.495,0",
								fill: "#032478"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13006",
								"data-name": "Path 13006",
								d: "M76.8,84.855s.762-1.713,1.255-2.524,2.6-3.188,2.959-2.65,1.794,4.16,1.031,5.174.05,2.778-3.741,3.847Z",
								fill: "#ffae73"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13007",
								"data-name": "Path 13007",
								d: "M34.673,74.039s19.406,16.2,26.973,14.7a149.082,149.082,0,0,0,15-4.286L78.46,89.1s-8.144,11.047-16.635,11.12a48.375,48.375,0,0,1-23.077-5.746Z",
								fill: "#667ee8"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13008",
								"data-name": "Path 13008",
								d: "M.639,244.9s.563,9.088,2.322,9.218c.233.017,8.917.017,8.917.017l11.085-.064a3.6,3.6,0,0,0-3.313-3.235c-3.24-.565-8.663-2.842-10.626-7.125C6.959,239.209.639,244.9.639,244.9",
								fill: "#074a92"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13009",
								"data-name": "Path 13009",
								d: "M0,245.534a23.121,23.121,0,0,0,6,1.127,22.038,22.038,0,0,0,5.6-.8s.635-6.135,4.126-19.653c1.83-7.086,4.444-16.2,8.163-27.516C34.173,167.407,37.3,149.1,37.585,147.372c.015-.091.021-.137.021-.137l-.033-.015L5.962,133.341S9.869,176.46,4.884,193.01a69.836,69.836,0,0,0-1.809,7.929C-.073,218.917,0,245.534,0,245.534",
								fill: "#032478"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13010",
								"data-name": "Path 13010",
								d: "M15.728,226.209c1.83-7.085,4.444-16.195,8.163-27.516,10.282-31.285,13.409-49.587,13.694-51.321,0-.052-.006-.1-.012-.152L5.962,133.341s3.907,43.119-1.078,59.67c-.7,2.313,10.844,33.2,10.844,33.2",
								fill: "#061a3d"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13011",
								"data-name": "Path 13011",
								d: "M25.329,244.9s.563,9.088,2.322,9.218c.233.017,8.917.017,8.917.017l11.085-.064a3.6,3.6,0,0,0-3.313-3.235c-3.24-.565-8.664-2.842-10.626-7.125-2.065-4.505-8.385,1.189-8.385,1.189",
								fill: "#074a92"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13012",
								"data-name": "Path 13012",
								d: "M43.251,134.357a449.933,449.933,0,0,1-4.424,62.249c-4.834,34.307-3.195,48.87-3.195,48.87a32.938,32.938,0,0,1-4.662,1.185,21.171,21.171,0,0,1-6.917-.8s-6.92-34.32-4.936-51.492-9.475-58.923-9.475-58.923Z",
								fill: "#032478"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13013",
								"data-name": "Path 13013",
								d: "M20.836,68.97l6.17,4.046,5.621-1.589c1.027-1.466,1.3-4.291,1.314-6.739a42.028,42.028,0,0,0-.22-4.487L25.4,56.527l-3.107-1.369c.009.048.242,2.55.275,2.916a21.243,21.243,0,0,1-1.728,10.9",
								fill: "#ffae73"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13014",
								"data-name": "Path 13014",
								d: "M43.392,142.125c-7.68,7.416-36.747,6.168-38.538-2s1.953-69.549,15.073-73.4c2.722-.8,17.277,3.9,17.277,3.9A92.263,92.263,0,0,1,40.986,84.2c.29,1.48,1.139,17.166,1.774,31.84.3,6.863.547,13.506.675,18.37.117,4.557.122,7.55-.043,7.712",
								fill: "#899bfa"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13015",
								"data-name": "Path 13015",
								d: "M23.187,58.189c1.689,2.855,7.615,5.354,10.754,6.5a42.036,42.036,0,0,0-.22-4.488L25.4,56.527c-1.84-.024-2.961.387-2.209,1.662",
								fill: "#ffa05e"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13016",
								"data-name": "Path 13016",
								d: "M36.861,59.694S23.448,63.878,20.97,55.485s-5.876-13.506,2.583-16.533,11.076-.317,12.584,2.284,4.149,17.153.724,18.458",
								fill: "#ffae73"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13017",
								"data-name": "Path 13017",
								d: "M35.611,40.427s-.856,9.767-2.875,9.343-4.244-1.331-3.948,1.613-1.964,7.992-4.877,7.98c-6.246-.026-13.034-16.055-11.324-19.095,4.935-8.77,30.156-10.54,23.024.159",
								fill: "#0b3563"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13018",
								"data-name": "Path 13018",
								d: "M33.637,66.929c-.173-.073-9.985-4.474-11.133-4.1s-2.578,3.884-2.578,3.884L37.2,70.623s-1.36-2.765-3.567-3.694",
								fill: "#667ee8"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13019",
								"data-name": "Path 13019",
								d: "M94.727,114.465l-55,51.788c-1.078,1.015-2.438,1.338-3.021.718L34.844,165c-.584-.619-.179-1.957.9-2.972l55.005-51.788c1.078-1.015,2.438-1.339,3.022-.719l1.856,1.972c.584.62.179,1.958-.9,2.973",
								fill: "#0b4d87"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13020",
								"data-name": "Path 13020",
								d: "M63.859,143.527,39.722,166.252c-1.079,1.016-2.438,1.339-3.022.719L34.844,165c-.584-.62-.179-1.957.9-2.972L59.88,139.3Z",
								fill: "#6b98f6"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13021",
								"data-name": "Path 13021",
								d: "M82.084,94.911a43.113,43.113,0,1,0,71.458-43.326c-.22-.22-.447-.438-.676-.652A43.115,43.115,0,0,0,82.084,94.911m12.323-39.79a39.711,39.711,0,1,1,1.71,56.132,39.662,39.662,0,0,1-1.71-56.132",
								fill: "#0b4d87"
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_7649",
								"data-name": "Group 7649",
								opacity: .5,
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_7648",
									"data-name": "Group 7648",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_7647",
										"data-name": "Group 7647",
										children: /* @__PURE__ */ _jsx("path", {
											id: "Path_13022",
											"data-name": "Path 13022",
											d: "M152.247,109.54a39.712,39.712,0,1,1-1.712-56.13,39.557,39.557,0,0,1,1.712,56.13",
											fill: "#accefc"
										})
									})
								})
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13023",
								"data-name": "Path 13023",
								d: "M43.435,134.413C13.127,112.816,15.647,84,15.647,84c11.078,6.248,22.07,20.062,27.113,32.045.3,6.863.547,13.507.675,18.371",
								fill: "#667ee8"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13024",
								"data-name": "Path 13024",
								d: "M73.348,124.578a8.272,8.272,0,0,0,3.871-2.391s.912.062-.15,2.006c-.088.163-.285.581-.434.876a.188.188,0,0,0,.159.271c1.233.094,2.473-.394,4.849.1.328.068.423.853.41,1.188a3.031,3.031,0,0,1-.638,2.07c-.383.505-1.451,1.048-3.83,2.006-.906.364-3.5.089-5.926-.745l-1.94-.9.6-3.607.487.1c.774.162,1.733-.783,2.54-.981",
								fill: "#ffae73"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13025",
								"data-name": "Path 13025",
								d: "M25.053,70.624s-27.233,5.185,8.012,44.621c5.637,6.307,36.091,14.52,36.091,14.52s3.089-2.628,1.532-4.757c0,0-20.969-15.226-25.582-17.647-2.076-1.09-8.056-24.3-11.439-29.894a15.25,15.25,0,0,0-8.614-6.843",
								fill: "#899bfa"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13026",
								"data-name": "Path 13026",
								d: "M77.539,85.333a13.867,13.867,0,0,0,1.065-2.6,14.376,14.376,0,0,1,1.757-3.978c.185-.185.795.054.868.848a4.653,4.653,0,0,1-.438,1.722,19.367,19.367,0,0,0-.576,3.423c-.422,1.372-2.676.585-2.676.585",
								fill: "#ffae73"
							})
						]
					})
				})
			})
		})]
	})]
});
export default SvgNoCustomLists;
